import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <header className="about-header">
        <h1>Welcome to Online Vehicle Service</h1>
        <p>Your one-stop solution for all vehicle servicing needs</p>
      </header>
      <section className="about-content">
        <div className="about-card">
          <h2>Who We Are</h2>
          <p>We are a dedicated team of professionals providing top-notch vehicle service at your convenience.</p>
        </div>
        <div className="about-card">
          <h2>Our Mission</h2>
          <p>Our mission is to make vehicle maintenance easy and hassle-free with our online booking and servicing platform.</p>
        </div>
        <div className="about-card">
          <h2>Why Choose Us</h2>
          <ul>
            <li>Certified Technicians</li>
            <li>Quality Parts</li>
            <li>Convenient Scheduling</li>
            <li>Transparent Pricing</li>
          </ul>
        </div>
        <div><h1>Developer-Sivaramakrishnan</h1></div>

      </section>
    </div>
  );
}

export default About;
